<template>
	<div class="rowItemList">
		<template v-for="item in list" >
			<item-block :itemContent="item" ></item-block>
		</template>
	</div>
</template>
<script>
	import ItemBlock from "../components/ItemBlock.vue"
	export default{
		components:{
			ItemBlock
		},
		props:{
			list:Array
		},
		data(){
			return{

			}
		}
	}
</script>
<style lang="scss">
	.rowItemList{
		background:#fff;
		padding:0 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/RowItemList.vue